import * as Yup from "yup";

export const loginValidationSchema = Yup.object().shape({
	password: Yup.string().required("Password is required"),
	email: Yup.string("Email is required")
		.email("Invalid email")
		.required("Email is required"),
});
